"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const audience_1 = require("modules/audience");
class UsersListTrackingService {
    constructor() {
        this.sendEvent = (name) => {
            DatahubService_1.default.sendMetrify({
                group: constants_1.GROUPS.USERS_LIST_BULK_ACTIONS,
                name,
                params: {
                    ucode: audience_1.ExtensionsUserInfoStore.ucode
                }
            }, { system: constants_1.SYSTEMS.LEAD_SOLUTIONS });
        };
        this.sendSendCommunicationsEvent = () => this.sendEvent(constants_1.NAMES.USERS_LIST_BULK_ACTIONS.SEND_COMMUNICATIONS);
        this.sendOpenBulkActionsSelectEvent = () => this.sendEvent(constants_1.NAMES.USERS_LIST_BULK_ACTIONS.OPEN_BULK_ACTIONS_SELECT);
    }
}
exports.default = new UsersListTrackingService();
